/* SEERAT v5.4.0 — Facticied */
(function () {
  'use strict';

  function Gallery(root) {
    this.root = root;
    this.track = root.querySelector('[data-rg-track]');
    this.items = Array.prototype.slice.call(root.querySelectorAll('[data-rg-item]'));
    // When the row scrolls on its own every screenshot is on the page twice.
    // The lightbox counts and steps through the real ones only, or it would
    // say "3 of 24" and show the same message twice on the way round.
    this.slides = this.items.filter(function (el) { return !el.hasAttribute('data-rg-clone'); });
    this.dialog = root.querySelector('[data-rg-dialog]');
    this.img = root.querySelector('[data-rg-img]');
    this.caption = root.querySelector('[data-rg-caption]');
    this.count = root.querySelector('[data-rg-count]');
    this.index = 0;
    this.bindArrows();
    this.bindLightbox();
    this.bindHold();
    this.masonry();
  }

  // Grid layout: place each screenshot in the shortest column so no column is left empty
  Gallery.prototype.masonry = function () {
    var root = this.root;
    var track = this.track;
    if (!track || !root.classList.contains('seerat-rg--grid')) return;
    var lis = Array.prototype.slice.call(track.querySelectorAll('.seerat-rg__li'));
    var ratios = lis.map(function (li) {
      var img = li.querySelector('img');
      var w = img ? parseFloat(img.getAttribute('width')) : 0;
      var h = img ? parseFloat(img.getAttribute('height')) : 0;
      return w && h ? h / w : 1.6;
    });
    var desktopCols = parseInt(root.getAttribute('data-cols'), 10) || 5;
    var current = 0;

    function colsNow() {
      var w = window.innerWidth;
      return w >= 990 ? desktopCols : (w >= 750 ? 3 : 2);
    }

    function layout() {
      var n = Math.min(colsNow(), lis.length || 1);
      if (n === current) return;
      current = n;
      var cols = [];
      var heights = [];
      track.innerHTML = '';
      for (var c = 0; c < n; c++) {
        var col = document.createElement('div');
        col.className = 'seerat-rg__col';
        track.appendChild(col);
        cols.push(col);
        heights.push(0);
      }
      lis.forEach(function (li, i) {
        var k = heights.indexOf(Math.min.apply(null, heights));
        cols[k].appendChild(li);
        heights[k] += ratios[i];
      });
      root.classList.add('is-masonry');
    }

    layout();
    var timer = null;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(layout, 150);
    });
  };

  Gallery.prototype.bindArrows = function () {
    var track = this.track;
    var prev = this.root.querySelector('[data-rg-prev]');
    var next = this.root.querySelector('[data-rg-next]');
    if (!track || !prev || !next) return;

    function step() {
      var first = track.querySelector('[data-rg-item]');
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return first ? first.getBoundingClientRect().width + gap : track.clientWidth;
    }
    function update() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  Gallery.prototype.show = function (i) {
    var n = this.slides.length;
    if (!n) return;
    this.index = (i + n) % n;
    var item = this.slides[this.index];
    this.img.src = item.getAttribute('data-full');
    this.img.alt = item.getAttribute('data-alt') || '';
    if (this.caption) {
      var cap = item.getAttribute('data-caption') || '';
      this.caption.textContent = cap;
      this.caption.hidden = !cap;
    }
    if (this.count) this.count.textContent = (this.index + 1) + ' / ' + n;
  };

  Gallery.prototype.bindLightbox = function () {
    var self = this;
    var d = this.dialog;
    if (!d || typeof d.showModal !== 'function') return;

    this.items.forEach(function (item) {
      item.addEventListener('click', function () {
        // A copy carries the same index as the screenshot it was made from.
        var idx = parseInt(item.getAttribute('data-rg-index'), 10);
        self.show(isNaN(idx) ? 0 : idx - 1);
        d.showModal();
        document.documentElement.classList.add('seerat-lock');
      });
    });

    d.addEventListener('close', function () {
      document.documentElement.classList.remove('seerat-lock');
      var back = self.slides[self.index];
      if (back) back.focus();
    });

    d.querySelector('[data-rg-close]').addEventListener('click', function () { d.close(); });
    d.querySelector('[data-rg-lprev]').addEventListener('click', function () { self.show(self.index - 1); });
    d.querySelector('[data-rg-lnext]').addEventListener('click', function () { self.show(self.index + 1); });
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });

    d.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.show(self.index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.show(self.index - 1); }
    });

    var startX = null;
    d.addEventListener('touchstart', function (e) { startX = e.changedTouches[0].clientX; }, { passive: true });
    d.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (dx > 50) self.show(self.index - 1);
      if (dx < -50) self.show(self.index + 1);
      startX = null;
    }, { passive: true });
  };

  /* A finger has no hover, so the row would keep sliding while someone is
     trying to tap a screenshot. Holding anywhere stops it, and it starts
     again a moment after they let go. */
  Gallery.prototype.bindHold = function () {
    var self = this;
    if (!this.root.classList.contains('seerat-rg--marquee')) return;
    var release = null;

    this.root.addEventListener('touchstart', function () {
      clearTimeout(release);
      self.root.classList.add('is-held');
    }, { passive: true });

    ['touchend', 'touchcancel'].forEach(function (evt) {
      self.root.addEventListener(evt, function () {
        clearTimeout(release);
        release = setTimeout(function () { self.root.classList.remove('is-held'); }, 1200);
      }, { passive: true });
    });

    // Nothing should be moving behind an open lightbox either.
    if (this.dialog) {
      this.dialog.addEventListener('close', function () {
        self.root.classList.remove('is-held');
      });
    }
  };

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-seerat-rg]'), function (el) {
      if (el.dataset.ready === 'true') return;
      el.dataset.ready = 'true';
      new Gallery(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
